import CollectingData from '../../../containers/CollectingData';
import MotionWrapper from '../../../containers/MotionWrapper';
import { useCodingExam } from './hooks/useCodingExam';
import BreakModal from './components/BreakModal';
import ExamHeader from './components/ExamHeader';
import PreExam from './components/PreExam';
import KYC from '../../../containers/KYC';
import ExamEnd from './containers/ExamEnd';
import styles from './style.module.scss';
import Exam from './containers/Exam';

/** Walks the applicant through the steps of a coding exam. */
function CodingExam() {
    const {
        phase,
        jobId,
        langs,
        examId,
        action,
        userId,
        profile,
        counter,
        question,
        jobTitle,
        language,
        webcamRef,
        isLoading,
        cameraAccess,
        selectedLang,
        examLanguage,
        examLanguages,
        isCameraActive,
        uploadProgress,
        questionNumber,
        isScreenRecording,
        screenRecordFailed,
        submit,
        exitExam,
        setAnswer,
        startExam,
        onKYCSuccess,
        nextQuestion,
        enableCamera,
        startCapture,
        onCameraError,
        setSelectedLang,
        setExamLanguage,
        onCameraStream,
        startScreenRecord,
    } = useCodingExam();

    return (
        <MotionWrapper className={styles.container}>
            <ExamHeader
                phase={phase}
                onExit={exitExam}
                onSubmit={submit}
                language={language}
                jobTitle={jobTitle}
                webcamRef={webcamRef}
                submitting={isLoading}
                cameraAccess={cameraAccess}
                onCameraError={onCameraError}
                onCameraStream={onCameraStream}
            />

            <div className={styles.main}>
                {phase === 'KYC' && <KYC
                    userId={userId}
                    examType='coding'
                    profile={profile}
                    jobId={jobId || null}
                    examId={examId || null}
                    onSuccess={onKYCSuccess}
                />}

                {phase === 'PreExam' && <PreExam
                    action={action}
                    langs={langs || []}
                    loading={isLoading}
                    onStart={startExam}
                    selectedLang={selectedLang}
                    cameraAccess={cameraAccess}
                    onSelectLang={setSelectedLang}
                    examLanguage={examLanguage}
                    examLanguages={examLanguages}
                    onSelectExamLanguage={setExamLanguage}
                    isCameraActive={isCameraActive}
                    onEnableCamera={enableCamera}
                    isScreenRecording={isScreenRecording}
                    screenRecordFailed={screenRecordFailed}
                    onStartScreenRecord={startScreenRecord}
                />}

                {(phase === 'Question' || phase === 'Break') && question && <Exam
                    userId={userId}
                    examId={examId}
                    counter={counter}
                    question={question}
                    webcamRef={webcamRef}
                    onAnswerChange={setAnswer}
                    onStartCapture={startCapture}
                    questionNumber={questionNumber}
                    isPaused={phase === 'Break'}
                />}

                {phase === 'CollectingData' && <CollectingData
                    progress={uploadProgress}
                    description='Please remain on this page while we collect your exam data.'
                />}

                {phase === 'ExamEnd' && <ExamEnd />}

                {phase === 'Break' && <BreakModal
                    loading={isLoading}
                    onNext={nextQuestion}
                />}
            </div>
        </MotionWrapper>
    )
};

export default CodingExam;
